function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TabGeneralView from '@/components/tableau/datasource/TabGeneralView';
import TabColumnView from '@/components/tableau/datasource/TabColumnView';
import TabConnectionView from '@/components/tableau/datasource/TabConnectionView';
import TabBusinessTermView from '@/components/tableau/datasource/TabBusinessTermView';
import TabBusinessTermDatasource from '@/components/tableau/datasource/TabBusinessTermDatasource';
import DatasourceTabLineage from '@/modules/tasks/tableau/components/datasource/DatasourceTabLineage';
import TabHistoryLogView from '@/components/tableau/TabHistoryLogView';
import { ACCESS_TYPE_FLOW, ENVIRONMENT_FLOW, GA_EVENTS } from '@/js/constants';
import tasks from '@/js/tasks';
import TableauDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
import TablesService from '@/apps/data-platform/services/tables_views/tables_service';
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'FormMetaDatasource',
  components: {
    TabGeneralView: TabGeneralView,
    TabColumnView: TabColumnView,
    TabBusinessTermView: TabBusinessTermView,
    DatasourceTabLineage: DatasourceTabLineage,
    TabHistoryLogView: TabHistoryLogView,
    TabConnectionView: TabConnectionView,
    TabBusinessTermDatasource: TabBusinessTermDatasource
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    isChangeRequest: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    showButtons: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      // email_regex: new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+" + `@${window.userInfo.domain}$`),
      email_regex: new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}\.[a-z]{2,3}'),
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      environ_initial: '',
      response_text: '',
      objetoInicial: null,
      valid: {
        organization: true,
        database_engine: true,
        data_operator: true,
        kdomain: true,
        ksubdomain: true,
        table: true,
        object_description: true,
        response_text: true
      },
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      tabActive: 'GENERAL',
      tab: null,
      validform: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'orgs'])), {}, {
    composeName: function composeName() {
      return "DATASOURCE: ".concat(this.item.path_name, "/").concat(this.item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
    },
    texts: function texts() {
      return {
        connections: this.traductor('tabs.connections'),
        bterm: this.traductor('tabs.bterm'),
        lineage: this.traductor('tabs.lineage'),
        logs: this.traductor('tabs.logs')
      };
    }
  }),
  created: function created() {
    this.environ_initial = this.item['environment'];
    this.objetoInicial = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    showTable: function showTable(item) {
      var _this = this;
      var params = {
        project_name: item.project_name,
        dataset_name: item.dataset_name,
        object_name: item.table_name
      };
      TablesService.getTable(params).then(function (res) {
        console.log(res.data);
        if (res.data && res.success) {
          if (res.data.tables && res.data.tables.length > 0) {
            console.log(res);
            _this.$emit('onShowTable', res.data.tables[0]);
          }
        }
      });
    },
    onCancel: function onCancel() {
      this.$emit('onCloseModal');
    },
    onReject: function onReject() {
      var _this2 = this;
      if (this.response_text.trim() === '') {
        this.valid_response_text = false;
        this.dangerMessage = 'Please complete Response reason';
        this.dismissCountDown = this.dismissSecs;
        return;
      }
      var data = _objectSpread(_objectSpread({
        response: this.response_text,
        domain: window.userInfo.domain
      }, this.item), {}, {
        status: 'REJECTED',
        type_flow: this.isChangeRequest
      });
      TableauDatasourceService.tableauDataSourceSendAssignment(data).then(function (res) {
        if (res.code === 200 && res.success) {
          if (_this2.$gtm.enabled() && window.dataLayer) {
            window.dataLayer.push({
              event: GA_EVENTS.ACCESS_REQUEST_MANAGEMENT,
              object: 'tbl_datasource',
              domain_object: _this2.item.organization,
              operator: _this2.stringToHash(_this2.item.data_operator),
              company_code: _this2.companyCode,
              id_object: _this2.item.id,
              hash_email: _this2.stringToHash(userInfo.email),
              module: 'data_platform',
              status: 'accepted'
            });
          }
          tasks.toast.success("Solicitud rechazada correctamente.");
          _this2.onCancel();
        } else {
          tasks.toast.error(res.message);
        }
      });
    },
    onSave: function onSave() {
      var _this3 = this;
      console.log(this.item);
      var formElement = this.$refs.form;
      console.log('form:', formElement.validate());
      var isValid = true;
      this.valid.organization = true;
      this.valid.database_engine = true;
      this.valid.data_operator = true;
      this.valid.kdomain = true;
      this.valid.ksubdomain = true;
      this.valid.response_text = true;
      if (formElement.validate()) {
        if (this.isChangeRequest === ACCESS_TYPE_FLOW.ASSIGN_DATA_OPERATOR) {
          if (this.item.environment === ENVIRONMENT_FLOW.DEV) {
            var datasource = {
              domain: window.userInfo.domain,
              datasource: this.item
            };
            TableauDatasourceService.tableauDataSourceAddUpdate(datasource).then(function (res) {
              if (res.success && res.code === 200) {
                if (res.success) {
                  tasks.toast.success('Datasource fields updated !');
                  // this.$toast.success("Datasource fields updated !")
                  _this3.onCancel();
                  _this3.$emit('onSave', datasource.datasource);
                } else {
                  tasks.toast.error(res.message);
                  // this.$toast.warning(res.message)
                  _this3.onCancel();
                }
              }
            });
          } else {
            if (this.item.columns.some(function (column) {
              return !column.business_definition;
            })) {
              tasks.toast.error('Please check Business definition in Columns tab');
              // this.$toast.warning("Please check Business definition in Columns tab")
              return;
            }
            this.$set(this.item, 'type_flow', 'APPROVE_OWNER');
            this.$set(this.item, 'document_id', this.item.id);
            var _datasource = {
              domain: window.userInfo.domain,
              comentary: this.response_text,
              datasource: this.item,
              type_flow: ACCESS_TYPE_FLOW.APPROVE_OWNER
            };
            TableauDatasourceService.tableauDataSourceInitWorkFlow(_datasource).then(function (res) {
              if (res && res.code === 200) {
                if (res.success) {
                  tasks.toast.success('Done. Check the ownership workflow.');
                  // this.$toast.success("Check the ownership workflow")
                  if (_this3.$gtm.enabled() && window.dataLayer) {
                    window.dataLayer.push({
                      event: GA_EVENTS.ASSIGN_OPERATOR,
                      object: 'tbl_datasource',
                      domain_object: _datasource.datasource.organization,
                      operator: _this3.stringToHash(_datasource.datasource.data_operator),
                      company_code: _this3.companyCode,
                      id_object: _datasource.datasource.id,
                      hash_email: _this3.stringToHash(userInfo.email),
                      module: 'data_platform'
                    });
                  }
                  _this3.onCancel();
                } else {
                  tasks.toast.error(res.message);
                  // this.$toast.warning(res.message)
                  _this3.onCancel();
                }
              }
            });
          }
        } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.APPROVE_OWNER) {
          var data = _objectSpread(_objectSpread({
            response_text: this.response_text,
            domain: window.userInfo.domain
          }, this.item), {}, {
            status: 'APPROVED',
            type_flow: ACCESS_TYPE_FLOW.APPROVE_OWNER
          });
          TableauDatasourceService.tableauDataSourceSendAssignment(data).then(function (res) {
            if (res.code === 200 && res.success) {
              if (_this3.$gtm.enabled() && window.dataLayer) {
                window.dataLayer.push({
                  event: GA_EVENTS.OWNERSHIP,
                  object: 'tbl_datasource',
                  domain_object: _this3.item.organization,
                  operator: _this3.stringToHash(_this3.item.data_operator),
                  company_code: _this3.companyCode,
                  id_object: _this3.item.id,
                  hash_email: _this3.stringToHash(userInfo.email),
                  module: 'data_platform',
                  status: 'accepted'
                });
              }
              tasks.toast.success('Done. Now this datasource will available in "My DataSources".');
              // this.$toast.success('Now this datasource will available in "My DataSources"')
              _this3.onCancel();
            } else {
              tasks.toast.error(res.message);
            }
          });
        } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.CHANGE_METADATA) {
          if (JSON.stringify(this.objetoInicial) === JSON.stringify(this.item)) {
            tasks.toast.error('No change has been made to the request');
            // this.$toast.warning("No change has been made to the request")
            return;
          }
          var _datasource2 = {
            domain: window.userInfo.domain,
            comentary: this.response_text,
            datasource: this.item,
            type_flow: ACCESS_TYPE_FLOW.CHANGE_METADATA
          };
          TableauDatasourceService.tableauDataSourceInitWorkFlow(_datasource2).then(function (res) {
            if (res && res.code === 200) {
              if (res.success) {
                if (_this3.$gtm.enabled() && window.dataLayer) {
                  window.dataLayer.push({
                    event: GA_EVENTS.CHANGE_METADATA,
                    object: 'tbl_datasource',
                    domain_object: _datasource2.datasource.organization,
                    operator: _this3.stringToHash(_datasource2.datasource.data_operator),
                    company_code: _this3.companyCode,
                    id_object: _datasource2.datasource.id,
                    hash_email: _this3.stringToHash(userInfo.email),
                    module: 'data_platform'
                  });
                }
                tasks.toast.success('Successful request');
                // this.$toast.success("Successful request")
                _this3.onCancel();
              } else {
                tasks.toast.error(res.message);
                // this.$toast.warning(res.message)
                _this3.onCancel();
              }
            }
          });
        }
      }
      /* if (this.isChangeRequest === ACCESS_TYPE_FLOW.ASSIGN_DATA_OPERATOR) {
        if (this.item.environment === ENVIRONMENT_FLOW.DEV) {
          if (this.item.data_operator.trim() === '') {
            this.valid.data_operator = false
            return
          } else if (this.item.data_operator.trim() !== '' && (!this.item.data_operator || !this.email_regex.test(this.item.data_operator))) {
            this.dangerMessage = 'Please check data operator email format (example@domain.com.pe)'
            this.dismissCountDown = this.dismissSecs
            return
          }
           // Generamos la data
          const datasource = {
            domain: window.userInfo.domain,
            datasource: this.item
          }
          apiDatasource.tableauDataSourceAddUpdate(datasource).then((res) => {
            if (res.success && res.code === 200) {
              if (res.success) {
                alert('Datasource fields updated !')
                this.onCancel()
                this.$emit('onSave', datasource.datasource)
              } else {
                alert(res.message)
                this.onCancel()
              }
            }
          })
        } else {
          if (this.item.organization.trim() === '') {
            this.valid.organization = false
            isValid = false
          }
          if (this.item.database_engine.trim() === '') {
            this.valid.database_engine = false
            isValid = false
          }
          if (this.item.data_operator.trim() === '') {
            this.valid.data_operator = false
            isValid = false
          }
          if (this.item.kdomain.trim() === '') {
            this.valid.kdomain = false
            isValid = false
          }
          if (this.item.ksubdomain.trim() === '') {
            this.valid.ksubdomain = false
            isValid = false
          }
           if (!this.item.object_description || !this.item.object_description.trim()) {
            this.dangerMessage =
              'Please check Table Description (The following characters are not allowed (,) (|) and (line break))'
            this.dismissCountDown = this.dismissSecs
            return
          }
          if (this.item.columns.some(column => !column.business_definition)) {
            this.dangerMessage = 'Please check Business definition in Columns tab'
            this.dismissCountDown = this.dismissSecs
            return
          }
          if (isValid) {
            this.$set(this.item, 'type_flow', 'APPROVE_OWNER')
            this.$set(this.item, 'document_id', this.item.id)
             const datasource = {
              domain: window.userInfo.domain,
              comentary: this.response_text,
              datasource: this.item
            }
            apiDatasource.tableauDataSourceInitWorkFlow(datasource).then((res) => {
              if (res && res.code === 200) {
                if (res.success) {
                  alert('Check the ownership workflow')
                  this.onCancel()
                } else {
                  alert(res.message)
                  this.onCancel()
                }
              }
            })
          } else {
            this.dangerMessage = 'Please check the fields in all tabs (General and Columns)!'
            this.dismissCountDown = this.dismissSecs
            return false
          }
        }
      } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.APPROVE_OWNER) {
        if (this.response_text.trim() === '') {
          this.dangerMessage = 'Please complete Response reason'
          this.dismissCountDown = this.dismissSecs
          isValid = false
          this.valid.response_text = false
          return
        }
        if (isValid) {
          const data = {
            response_text: this.response_text,
            domain: window.userInfo.domain,
            ...this.item,
            status: 'APPROVED',
            type_flow: ACCESS_TYPE_FLOW.APPROVE_OWNER
          }
          apiDatasource.tableauDataSourceSendAssignment(data).then((res) => {
            if (res.code === 200 && res.success) {
              alert('Now this datasource will available in "My DataSources"')
              this.onCancel()
            }
          })
        }
      } else if (this.isChangeRequest === ACCESS_TYPE_FLOW.CHANGE_METADATA) {
        if (this.item.organization.trim() === '') {
          this.valid.organization = false
          isValid = false
        }
        if (this.item.database_engine.trim() === '') {
          this.valid.database_engine = false
          isValid = false
        }
        if (this.item.data_operator.trim() === '') {
          this.valid.data_operator = false
          isValid = false
        }
        if (this.item.kdomain.trim() === '') {
          this.valid.kdomain = false
          isValid = false
        }
        if (this.item.ksubdomain.trim() === '') {
          this.valid.ksubdomain = false
          isValid = false
        }
        if (this.item.object_description.trim() === '') {
          this.dangerMessage =
            'Please check Table Description (The following characters are not allowed (,) (|) and (line break))'
          this.dismissCountDown = this.dismissSecs
          return
        }
         if (JSON.stringify(this.objetoInicial) === JSON.stringify(this.item)) {
          this.dangerMessage = 'No change has been made to the request'
          this.dismissCountDown = this.dismissSecs
          return
        }
         if (isValid) {
          this.$set(this.item, 'type_flow', ACCESS_TYPE_FLOW.CHANGE_METADATA)
          this.$set(this.item, 'document_id', this.item.id)
           const datasource = {
            domain: window.userInfo.domain,
            comentary: this.response_text,
            datasource: this.item
          }
          apiDatasource.tableauDataSourceInitWorkFlow(datasource).then((res) => {
            if (res && res.code === 200) {
              if (res.success) {
                alert('Successful request')
                this.onCancel()
              } else {
                alert(res.message)
                this.onCancel()
              }
            }
          })
        }
      }*/
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  }
};